"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountType = void 0;
const Field_type_1 = require("../../../types/Field.type");
const AccountType_1 = require("../../enm/AccountType");
exports.AccountType = {
    priority: Number.MAX_VALUE,
    label: 'fields.enm.account_type.label',
    fallbackLabel: 'Bank account type',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['contract_onboarding_type'],
    type: Field_type_1.FieldType.Enum,
    options: AccountType_1.AccountTypeRef.options,
    trackFieldValueWithAnalytics: true,
};
function isMandatory(payload, path) {
    return false;
}
function isApplicable(payload, path) {
    return (payload.contract_onboarding_type?.valueOf?.() === 'MEDIA');
}
